// Firebase SDKs import karein
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { setAnalyticsCollectionEnabled } from "firebase/analytics";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCrB9vNhrbUPDIBGVx-42DIwppSWMhWSu4",
    authDomain: "mdmall-01.firebaseapp.com",
    projectId: "mdmall-01",
    storageBucket: "mdmall-01.firebasestorage.app",
    messagingSenderId: "41171394569",
    appId: "1:41171394569:web:331c207196431b637118d8",
    measurementId: "G-S6EY8GP2VV"
  };
// ✅ Firebase App Initialize karein
const app = initializeApp(firebaseConfig);

// ✅ Firebase Analytics Enable karein (Optional)
const analytics = getAnalytics(app);
// Enable debug mode to see events in real-time
//setAnalyticsCollectionEnabled(analytics, true);

// ✅ Firebase Instance Export karein taaki baaki components use kar sakein
export { app, analytics };
